import { render, staticRenderFns } from "./SignUpPageBeneficialOwners.vue?vue&type=template&id=01ee76ae&scoped=true&"
import script from "./SignUpPageBeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./SignUpPageBeneficialOwners.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPageBeneficialOwners.vue?vue&type=style&index=0&id=01ee76ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ee76ae",
  null
  
)

export default component.exports